export default __webpack_public_path__ + "static/media/view.8dc31ae9.svg";